/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderPageDataTypes {
  PERSONS = 'persons',
  DURATION = 'duration',
  CUSTOM = 'custom',
  ROOMS = 'rooms',
}
